import { render, staticRenderFns } from "./DialogACRMetadata.vue?vue&type=template&id=12c7e100&scoped=true"
import script from "./DialogACRMetadata.vue?vue&type=script&lang=js"
export * from "./DialogACRMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c7e100",
  null
  
)

export default component.exports